import React from 'react';
import { Box, Checkbox } from '@mui/material';

const HideLabel = ({ value, setFieldValue }) => {
    return (
        <Box>
            <Checkbox checked={Boolean(value)} onClick={(e) => setFieldValue('hide_label', e.target.checked)} />
            Hide Label
        </Box>
    );
};

export default HideLabel;
